<template>
  <div class="juou-card">
    <HpsfirProTable
      ref="tableRef"
      export-file-name="门店数据"
      title="门店数据"
      :paginations="{ pageSize: 10 }"
      :columns="columns"
      :get-data="getData"
      :loading="loading"
      :is-dangder-delete="true"
      :format-dangder-delete-info="formatDeleteInfo"
      row-key="id"
      :operates="operates"
      :add-init-values="addInitValue"
      :top-operates="topOperates"
      :codition-init-values="conditionsInitValue"
    />

    <Detail ref="detailRef" />

    <HpsfirProForm
      ref="exportDetailFormRef"
      :is-dialog="true"
      :dialog-width="600"
      title="导出详情"
      :items="exportDetailFormItems"
      :on-ok="handleExportDetail"
      :init-form-value="exportDetailInitValue"
    />
  </div>
</template>
<script lang="ts" setup>
import {
  useBaseAsync,
  useBaseOperateStore,
  type HpsfirProTableColumn,
  type HpsfirProTableData,
  type HpsfirProTableFilter,
  type HpsfirProTableGetDataFunction,
  type HpsfirProFormItem,
} from 'hpsfir-managebase-ui';

import { useApi } from '@/hooks/useApi';
import { ElMessage } from 'element-plus';
import { computed, ref } from 'vue';
import dayjs from 'dayjs';
import Detail from './detail.vue';
import { normalizeBizTableColumns } from '@/utils/tableColumns';

const columns = ref<HpsfirProTableColumn[]>(normalizeBizTableColumns([]));
const tableRef = ref<any>();
const detailRef = ref<InstanceType<typeof Detail>>();
const baseOperateStore = useBaseOperateStore();

const addInitValue = {

};
const conditionsInitValue = {
};

// 可管理服务商，则是管理员
const canAdminFacilitator = computed(() => baseOperateStore.operates?.find((item) => item.key === 'ADMIN_STORE_FACILITATOR'));

// eslint-disable-next-line max-lines-per-function
const init = useBaseAsync(() => {
  columns.value = normalizeBizTableColumns([
    ...(
      canAdminFacilitator.value ? [
        {
          name: 'remark',
          label: '设备备注',
          type: 'string',
          isCondition: true,
          hideEdit: true,
          hideCreate: true,
          order: 10,
        },
      ] : []
    ) as any,
    {
      name: 'name',
      label: '店铺名称',
      type: 'string',
      isCondition: true,
      rule: [{ required: true }],
    },
    {
      name: 'phone',
      label: '店主手机号',
      type: 'string',
      rule: [{ required: true }],
      isCondition: true,
    },
    {
      name: 'allCount',
      label: '历史开门次数',
      type: 'numberStr',
    },
    {
      name: 'allPeople',
      label: '历史开门人数',
      type: 'numberStr',
    },
    {
      name: 'lastdayCount',
      label: '昨日开门次数',
      type: 'numberStr',
    },
    {
      name: 'lastdayPeople',
      label: '昨日开门人数',
      type: 'numberStr',
    },
  ]);
});

const loading = ref(false);
const lastSyncTime = ref('');
const syncing = ref(false);
const exportDetailFormRef = ref<any>();
const exportDetailInitValue = {
  dateRange: [
    dayjs()
      .subtract(30, 'day')
      .format('YYYY-MM-DD'),
    dayjs()
      .format('YYYY-MM-DD'),
  ],
};
const exportDetailFormItems: HpsfirProFormItem[] = [
  {
    name: 'dateRange',
    label: '日期范围',
    type: 'datepick',
    pickType: 'daterange',
    startPlaceholder: '开始日期',
    endPlaceholder: '结束日期',
    rule: [{ required: true, message: '请选择日期范围' }],
  },
];

const operates: any[] = [
  {
    key: 'detail',
    name: '查看详情',
    handler: (row: any) => {
      detailRef.value?.show(row);
    },
  },
];

const getLastSyncTime = async() => {
  const res = await useApi().storeStatisticsApi.getSyncedMonthstoreStatistics();
  lastSyncTime.value = res.data.data?.syncMonth || '';
};

const handleSync = async() => {
  try {
    await useApi().storeStatisticsApi.syncStoreStatisticsstoreStatistics();
    ElMessage.success('提交同步成功');
    await getLastSyncTime();
    await tableRef.value?.refresh();
  } finally {
    console.log(123);
  }
};

const handleExportDetail = async(values: { dateRange: string[] }) => {
  const [start, end] = values.dateRange || [];
  const res = await useApi().storeStatisticsApi.exportStoreStatisticsstoreStatistics({
    conditions: {},
    start: start ? dayjs(start)
      .format('YYYY-MM-DD') : undefined,
    end: end ? dayjs(end)
      .format('YYYY-MM-DD') : undefined,
  });
  if (res.data.data?.file) {
    window.open(useApi().baseUrl + res.data.data.file, '_blank');
  }
  exportDetailFormRef.value?.hideDialog();
};

const topOperates = computed(() => [
  {
    key: 'sync',
    name: syncing.value ? '同步中...' : `同步(${lastSyncTime.value || '未同步'})`,
    handler: handleSync,
  },
  {
    key: 'exportDetail',
    name: '导出详情',
    handler: () => {
      exportDetailFormRef.value?.showDialog();
    },
  },
]);


// eslint-disable-next-line max-lines-per-function
const getData = useBaseAsync<HpsfirProTableGetDataFunction>(async(filter: HpsfirProTableFilter) => {
  try {
    loading.value = true;
    const params = {
      conditions: Object.entries(filter.conditions).reduce((conditions, [key, val]) => {
        if (val === null || val === undefined || val === '') {
          return conditions;
        }
        conditions[key] = val;
        return conditions;
      }, {} as any),

    };
    const res = await useApi().storeApi.pageStorestore({
      ...params,
      pageQuery: {
        page: filter.paginations.page - 1,
        pageSize: filter.paginations.pageSize,
      },


    });
    const tableData: HpsfirProTableData = {
      total: res.data.data?.total || 0,
      data: res.data.data?.data || [],
    };
    return tableData;
  } finally {
    loading.value = false;
  }
});

const formatDeleteInfo = (row: any) => `您正在进行删除(${row.idHex})操作，请谨慎操作`;


init();
getLastSyncTime();

</script>
<style lang="scss" scoped>
</style>
